/* Stack Finder — Web Search Tracker
   Logs cigar searches from the WEBSITE Stack Finder (sections/cigar-selector.liquid)
   to Firebase (/webSearches), so the owner dashboard's "Online" tab can show:
     • top searched cigars (web)
     • searched-but-NOT-in-catalog (what to stock)
   No PII is recorded — only the cigar text the visitor typed or selected.
   Works by observing the selector's own DOM (decoupled from its internal JS):
     - a clicked .cs-suggestion  → matched search
     - result cards rendered      → matched search (Enter-key path, backstop)
     - .cs-suggestion-empty shown → unmatched search (debounced "settled" check)
   © 2026 Cigar Stacks LLC. Stack Finder. Patent Pending. */
(function () {
  var FB = "https://aficionados-bar-default-rtdb.firebaseio.com/webSearches.json";
  var logged = {};          // dedupe per page view: one log per (type + query)
  var tries = 0;

  function logSearch(q, matched) {
    q = (q == null ? "" : String(q)).trim();
    if (q.length < 2 || q.length > 200) return;
    var key = (matched ? "m:" : "u:") + q.toLowerCase();
    if (logged[key]) return;
    logged[key] = true;
    try {
      fetch(FB, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ q: q, matched: !!matched, ts: Date.now(), source: "web" }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }

  function wire() {
    var input   = document.querySelector("input.cs-search-input");
    var sugg    = document.querySelector(".cs-suggestions");
    var results = document.querySelector('[id^="cs-results-"]');
    // Section may not be on this page (snippet also loads elsewhere) — give up quietly.
    if (!input || !sugg) {
      if (++tries < 12) setTimeout(wire, 900);
      return;
    }

    // MATCHED — visitor clicks a suggestion (the catalog cigar they were after).
    document.addEventListener("click", function (e) {
      var s = e.target && e.target.closest ? e.target.closest(".cs-suggestion") : null;
      if (s && sugg.contains(s)) {
        var span = s.querySelector("span");
        logSearch(span ? span.textContent : s.textContent, true);
      }
    }, true);

    // MATCHED (backstop) — result cards render after an Enter-key pick.
    if (results) {
      new MutationObserver(function () {
        if (results.querySelector(".cs-card")) logSearch(input.value, true);
      }).observe(results, { childList: true, subtree: true });
    }

    // NOT FOUND — suggestions show the "no matches" state for a settled query.
    var missT = null;
    new MutationObserver(function () {
      if (sugg.querySelector(".cs-suggestion-empty")) {
        clearTimeout(missT);
        missT = setTimeout(function () {
          if (sugg.querySelector(".cs-suggestion-empty") && input.value.trim().length >= 3) {
            logSearch(input.value, false);
          }
        }, 1300);
      }
    }).observe(sugg, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
})();
